import React from 'react';
import cx from 'classnames';
import styles from './ModalContent.module.css';
export const ModalContent = ({ className, children }) => (React.createElement("div", { className: cx(styles.component, className) }, children));
//# sourceMappingURL=ModalContent.js.map